'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _Constants = require('../actions/Constants');

var Constants = _interopRequireWildcard(_Constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Handles changing the form page.
 * @param {Number} state - The current page number.
 * @param {FSA} action - The dispatched action.
 * @returns {Number} The new page number.
 */
var currentPage = function currentPage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var action = arguments[1];

  switch (action.type) {
    case Constants.FORWARD_PAGE:
      return state + 1;
    case Constants.BACK_PAGE:
      return state - 1;
    default:
      return state;
  }
};

/**
 * Handles changing the count of form pages.
 * @param {Number} state - Current number of pages in the form.
 * @param {FSA} action - The dispatched action.
 * @returns {Number} The new number of pages in the form.
 */
var numPages = function numPages() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var action = arguments[1];

  switch (action.type) {
    case Constants.SET_NUM_PAGES:
      return action.payload.numPages;
    default:
      return state;
  }
};

exports.default = (0, _redux.combineReducers)({
  currentPage: currentPage,
  numPages: numPages
});


//////////////////
// WEBPACK FOOTER
// ./src/v2/reducers/navigation.js
// module id = 1715
// module chunks = 0